import styled from 'styled-components';
import { Badge as Component } from 'antd';

const Badge = styled(Component)``;

/** @component */
export default Badge;
